import React from 'react';
import { Input } from 'antd';
import './searchInput.scss';

const { Search } = Input;

interface SearchInputComponentProps {
    placeholder?: string;
    className?: string;
    onSearch?: (value: string) => void;
    onChangeEvent?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    disabled?: boolean;
    allowClear?: boolean;
    size?: 'large' | 'middle' | 'small';
    value?: string;
}

const SearchInputComponent = ({
    placeholder = 'Search',
    className = 'searchInputField',
    onSearch = () => {},
    onChangeEvent = () => {},
    style = {},
    disabled = false,
    allowClear = true,
    size = 'large',
    value = '',
}: SearchInputComponentProps) => {
    return (
        <Search
            placeholder={placeholder}
            className={className}
            onChange={onChangeEvent}
            allowClear={allowClear}
            size={size}
            onSearch={onSearch}
            style={style}
            disabled={disabled}
            value={value}
        />
    );
};

export default SearchInputComponent;
